/* eslint-disable @typescript-eslint/camelcase */
import * as DYNAMIC_FORM_ACTION_TYPE from "./actionTypes";

interface InitialState {
    draftList?: any;
    propertyManagerList?: any;
    deleteItem?: any;
    layoutResponse?: any;
    formId?: any;
    warrantyId?: any;
    warrantyInfo?: any;
    saveDesktopMsg?: any;
    isBuildingAddressAvailable?: boolean;
    saveMobileMsg?: any;
    global?: any;
    reviewAndPayData?: any;
    navigation?: any;
    errorDetails?: any;
    template?: any;
    templateList?: any;
    DeletedTemplate?: any;
    manageTemplate?: any;
    navMenus?: any;
    menuKeys?: any;
    isDraft?: any;
    isApiCallInProcess?: any;
    isLayoutCallInProcess?: any;
    isSubmitClicked?: any;
    clickDetails?: any;
    contractorSettings?: any;
    saveVariance?: any;
    isSavingVariance?: boolean;
}

export const initialState: InitialState = {
    draftList: [],
    propertyManagerList: [],
    deleteItem: null,
    layoutResponse: {},
    formId: null,
    warrantyId: null,
    warrantyInfo: {},
    saveDesktopMsg: "",
    isBuildingAddressAvailable: true,
    saveMobileMsg: "",
    global: {
        buildingAddress: {
            city: "",
            zip: "",
            state: "",
            postalCode: "",
            street: "",
            countryCode: "USA",
        },
        mailAddress: {
            city: "",
            zip: "",
            state: "",
            postalCode: "",
            street: "",
            countryCode: "USA",
        },
        isTechSupportPopUpShown: false,
    },
    reviewAndPayData: {},

    navigation: {
        navigable: false,
        message: "",
    },
    errorDetails: {},
    template: {},
    templateList: "",
    DeletedTemplate: {},
    manageTemplate: {},
    navMenus: [],
    menuKeys: [],
    isDraft: false,
    isApiCallInProcess: false,
    isLayoutCallInProcess: false,
    isSubmitClicked: false,
    clickDetails: {},
    contractorSettings: {},
    saveVariance: {},
    isSavingVariance: false,
};

const reducer = (state = initialState, action) => {
    const getMenuKeysArray = (values, arr) => {
        try {
            values &&
                Object.keys(values).length > 0 &&
                values.JSONSchema.properties.residentialWarrantyForm.dependencies.NavigationMenu.oneOf.forEach(
                    (item, index) => {
                        arr.push({
                            [item.properties.NavigationMenu.enum[0]]: Object.keys(item.properties)[1],
                            visitCount: index === 0 ? 2 : 0,
                        });
                    }
                );
        } catch (e) {}
        return arr;
    };

    switch (action.type) {
        case DYNAMIC_FORM_ACTION_TYPE.UPDATE_LOADING_STATUS: {
            return { ...state, loading: action.payload };
        }
        case DYNAMIC_FORM_ACTION_TYPE.UPDATE_WARRANTY_ID: {
            return { ...state, warrantyId: action.payload };
        }
        case DYNAMIC_FORM_ACTION_TYPE.FETCH_SAVED_FORM_LAYOUT_DATA_SUCCESS: {
            const arr = getMenuKeysArray(action.value, []);
            return {
                ...state,
                layoutResponse: action.value,
                warrantyId: action.value.id,
                warrantyInfo: action.value.WarrantyData,
                //navMenus: [],
                formId: 1,
                menuKeys: arr,
                navigation: {
                    navigable: false,
                    message: "",
                },
            };
        }
        case DYNAMIC_FORM_ACTION_TYPE.FETCH_SAVED_FORM_DATA_SUCCESS: {
            let stateObj = {};
            if (action.value.updateNavigation) {
                stateObj = {
                    ...state,
                    layoutResponse: {
                        ...state.layoutResponse,
                        WarrantyData: {
                            ...state.layoutResponse.WarrantyData,
                            residentialWarrantyForm: {
                                ...state.layoutResponse.WarrantyData.residentialWarrantyForm,
                                NavigationMenu: action.value.updateNavigation,
                            },
                        },
                    },
                    warrantyInfo: {
                        ...state.warrantyInfo,
                        residentialWarrantyForm: {
                            ...state.warrantyInfo.residentialWarrantyForm,
                            NavigationMenu: action.value.updateNavigation,
                        },
                    },
                };
            } else {
                stateObj = {
                    ...state,
                    layoutResponse: { ...state.layoutResponse, WarrantyData: action.value.WarrantyData },
                    warrantyInfo: action.value.WarrantyData,
                };
            }
            return {
                ...stateObj,
            };
        }
        case DYNAMIC_FORM_ACTION_TYPE.FETCH_FORM_LAYOUT_DATA_SUCCESS: {
            const arr = getMenuKeysArray(action.value, []);
            return {
                ...state,
                layoutResponse: action.value,
                formId: action.value.id,
                warrantyId: null,
                errorDetails: {},
                //navMenus: [],
                menuKeys: arr,
                navigation: {
                    navigable: false,
                    message: "",
                },
                isLayoutCallInProcess: false,
            };
        }
        case DYNAMIC_FORM_ACTION_TYPE.MODIFY_FORM_DATA: {
            return { ...state, warrantyInfo: action.payload };
        }
        case DYNAMIC_FORM_ACTION_TYPE.SAVE_DRAFT_FORM_SUCCESS:
        case DYNAMIC_FORM_ACTION_TYPE.UPDATE_DRAFT_FORM_SUCCESS: {
            if (typeof action.payload === "string") {
                return { ...state, saveMobileMsg: action.payload, saveDesktopMsg: action.payload };
            } else {
                return {
                    ...state,
                    saveMobileMsg: action.payload.mobileMsg,
                    saveDesktopMsg: action.payload.desktopMsg,
                    layoutResponse: { ...state.layoutResponse, WarrantyData: action.payload.updateWarrantyData },
                };
            }
        }
        case DYNAMIC_FORM_ACTION_TYPE.UPDATE_BILLING_ADDRESS_STATUS: {
            return { ...state, isBuildingAddressAvailable: action.payload };
        }
        case DYNAMIC_FORM_ACTION_TYPE.REMOVE_FORM_LAYOUT_DATA: {
            return {
                ...state,
                layoutResponse: {
                    ...state.layoutResponse,
                    id: null,
                    WarrantyData: null,
                    isSavedDraft: false,
                    forminstanceTypeId: 1,
                },
                warrantyInfo: {},
                errorDetails: {},
                warrantyId: null,
                formId: 1,
            };
            // }
        }
        case DYNAMIC_FORM_ACTION_TYPE.GET_COUNTRY_CODE_ASYNC: {
            return { ...state, countryCode: action.value };
        }
        case DYNAMIC_FORM_ACTION_TYPE.GET_COUNTRY_CODE_BUILDINGADDR_ASYNC: {
            return {
                ...state,
                global: {
                    ...state.global,
                    buildingAddress: {
                        ...state.global.buildingAddress,
                        countryCode: action.value,
                    },
                },
            };
        }
        case DYNAMIC_FORM_ACTION_TYPE.GET_COUNTRY_CODE_MAILADDRESS_ASYNC: {
            return {
                ...state,
                global: {
                    ...state.global,
                    mailAddress: {
                        ...state.global.mailAddress,
                        countryCode: action.value,
                    },
                },
            };
        }
        case DYNAMIC_FORM_ACTION_TYPE.SET_SELECTED_ADDRESS_ASYNC: {
            let addressObj = { ...state.global[action.key] };
            if (action.label) {
                addressObj[action.label] = action.value[action.label];
            } else {
                addressObj = { ...action.value };
            }
            return {
                ...state,
                global: {
                    ...state.global,
                    [action.key]: {
                        ...addressObj,
                    },
                },
            };
        }
        /**
         * @description :In this case it will map a response from saga function getReviewAndPayData
         * function and will store the response to store i.e reviewAndPayData{}
         * which we will be accessing by connecting the component, which can be seen in review&Pay index
         */
        case DYNAMIC_FORM_ACTION_TYPE.SET_REVIEW_AND_PAY_TO_REDUX_STORE: {
            return { ...state, reviewAndPayData: action.value };
        }

        case DYNAMIC_FORM_ACTION_TYPE.UPDATE_NAVIGATION_MENU_STATUS: {
            return { ...state, navigation: action.payload };
        }

        case DYNAMIC_FORM_ACTION_TYPE.CLEAR_NAVIGATION_MENU_STATUS: {
            return { ...state, navigation: { navigable: false, message: "" } };
        }
        case DYNAMIC_FORM_ACTION_TYPE.ADD_FIELD_ID_TO_STORE: {
            return { ...state, errorDetails: { ...state.errorDetails, [action.payload.id]: [action.payload.msg] } };
        }
        case DYNAMIC_FORM_ACTION_TYPE.REMOVE_FIELD_ID_FROM_STORE: {
            delete state.errorDetails[action.id];
            return { ...state, errorDetails: { ...state.errorDetails } };
        }
        case DYNAMIC_FORM_ACTION_TYPE.FETCH_ERROR_RESPONSE_SUCCESS: {
            return { ...state, errorDetails: action.response.errors.formValidationSummary, variance: action.response.variance
            };
        }
        case DYNAMIC_FORM_ACTION_TYPE.FETCH_ERROR_RESPONSE: {
            return { ...state };
        }
        case DYNAMIC_FORM_ACTION_TYPE.ADD_TAB_DETAILS_TO_STORE: {
            return { ...state, menuKeys: action.keyArray };
        }
        /**
         * @description :In this case it will map a response from saga function getTemplate
         * and Update the store
         */
        case DYNAMIC_FORM_ACTION_TYPE.SET_TEMPLATE_DATA: {
            return { ...state, templates: action.value };
        }

        /**
         * @description :This will save the template in the DB
         */
        case DYNAMIC_FORM_ACTION_TYPE.SAVE_TEMPLATE: {
            return { ...state, templates: action.value };
        }
        /**
         * @description :This will get and Update the template to store
         */
        case DYNAMIC_FORM_ACTION_TYPE.SET_TEMPLATE_LIST: {
            return {
                ...state,
                templateList: action.value,
            };
        }
        case DYNAMIC_FORM_ACTION_TYPE.ADD_NAV_MENUS_TO_STORE: {
            return { ...state, navMenus: action.navMenus };
        }
        /**
         * @description :This for updating
         */
        case DYNAMIC_FORM_ACTION_TYPE.UPDATE_PROJECT_DETAILS: {
            const payload = {
                warrantyType: state.warrantyInfo.residentialWarrantyForm.projectDetails.warrantyType,
                dateOfInstallation: state.warrantyInfo.residentialWarrantyForm.projectDetails.dateOfInstallation,
                steepSlopeSq: state.warrantyInfo.residentialWarrantyForm.projectDetails.steepSlopeSq,
                jobType: state.warrantyInfo.residentialWarrantyForm.projectDetails.jobType,
                installCost: state.warrantyInfo.residentialWarrantyForm.projectDetails.installCost,
                roofPitch: state.warrantyInfo.residentialWarrantyForm.projectDetails.roofPitch,
                myTemplate: {},
            };
            if (!action.value.isClear) {
                payload.myTemplate = state.warrantyInfo.residentialWarrantyForm.projectDetails.myTemplate;
            }
            return {
                ...state,
                layoutResponse: {
                    ...state.layoutResponse,
                    WarrantyData: {
                        ...state.layoutResponse.WarrantyData,
                        residentialWarrantyForm: {
                            ...state.layoutResponse.WarrantyData.residentialWarrantyForm,
                            projectDetails: {
                                ...action.value,
                                ...payload,
                            },
                        },
                    },
                },
                warrantyInfo: {
                    ...state.warrantyInfo,
                    residentialWarrantyForm: {
                        ...state.warrantyInfo.residentialWarrantyForm,
                        projectDetails: {
                            ...action.value,
                            ...payload,
                        },
                    },
                },
            };
        }
        case DYNAMIC_FORM_ACTION_TYPE.UPDATE_MENU_COUNTER: {
            return { ...state, menuKeys: action.navMenus };
        }

        case DYNAMIC_FORM_ACTION_TYPE.CHECK_FORM_TYPE: {
            return { ...state, isDraft: action.status };
        }
        case DYNAMIC_FORM_ACTION_TYPE.TOGGLE_TECH_SUPPORT_POPUP: {
            return {
                ...state,
                global: {
                    ...state.global,
                    isTechSupportPopUpShown: action.status || false,
                },
            };
        }
        case DYNAMIC_FORM_ACTION_TYPE.API_RUNNING_STATUS: {
            return { ...state, isApiCallInProcess: action.status };
        }
        case DYNAMIC_FORM_ACTION_TYPE.LAYOUT_API_RUNNING_STATUS: {
            return { ...state, isLayoutCallInProcess: action.status };
        }
        case DYNAMIC_FORM_ACTION_TYPE.UPDATE_SUBMIT_CLICK_STATUS: {
            return { ...state, isSubmitClicked: action.status };
        }

        case DYNAMIC_FORM_ACTION_TYPE.CAPTURE_NAV_BUTTON_CLICK: {
            return { ...state, clickDetails: action.clickDetails };
        }
        case DYNAMIC_FORM_ACTION_TYPE.SET_CONTRACTOR_FORM_SETTINGS: {
            return { ...state, contractorSettings: action.contractorFormData };
        }
        case DYNAMIC_FORM_ACTION_TYPE.UPDATE_PROPERTY_MANAGER_LIST: {
            return { ...state, propertyManagerList: action.propertyManagerList };
        }
        case DYNAMIC_FORM_ACTION_TYPE.SAVE_WARRANTY_VARIANCE: {
            return {
                ...state,
                payload: action.data,
                isSavingVariance: true,
            }
        }
        case DYNAMIC_FORM_ACTION_TYPE.SAVE_WARRANTY_VARIANCE_SUCCESS: {
            return {
                ...state,
                saveVariance: action.data,
                isSavingVariance: false,
            }
        }
        case DYNAMIC_FORM_ACTION_TYPE.SAVE_WARRANTY_VARIANCE_FAILURE: {
            return {
                ...state,
                saveVariance: action.err,
                isSavingVariance: false,
            }
        }
        case DYNAMIC_FORM_ACTION_TYPE.CLEAR_WARRANTY_VARIANCE_DATA: {
            return {
                ...state,
                isSavingVariance: false,
                saveVariance: {},
            }
        }
        default:
            return state;
    }
};
export default reducer;
